import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hidden lg:block w-next-nav fixed h-menu bg-next-dark-gray z-10" }
const _hoisted_2 = { class: "grid grid-rows-7 h-full" }
const _hoisted_3 = { class: "flex-grow grid grid-rows-6 row-span-6 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_ProfileMenuButton = _resolveComponent("ProfileMenuButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MenuButton, {
        to: {name:'HomePermessi'},
        "icon-class": "icon-home"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_MenuButton, {
          to: {name:'ListaUtenti'},
          tooltip: "Utenti"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("span", { class: "text_vertical" }, "Utenti", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_MenuButton, {
          to: {name:'ListaRuoli'},
          tooltip: "Ruoli"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "text_vertical" }, "Ruoli", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_MenuButton, {
          to: {name:'ListaPermessi'},
          tooltip: "Permessi"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("span", { class: "text_vertical" }, "Perme.", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_MenuButton, {
          to: {name:'ListaAziendeGruppo'},
          tooltip: "Aziende gruppo"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("span", { class: "text_vertical" }, "Az. Gruppo", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_MenuButton, {
          to: {name:'BusinessUnits'},
          tooltip: "Business Unit"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createElementVNode("span", { class: "text_vertical" }, "Bu", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_ProfileMenuButton, {
          class: "row-start-6",
          notification: _ctx.meCounters?.notification_counter > 0
        }, null, 8, ["notification"])
      ])
    ])
  ]))
}